<template>
	<div class='province-wrap'>
		<div class="province-box">
			<div class="right-box">
				<img src="@/static/images/repair/sm.png" class="circle" alt="">
				<h3>信用修复说明</h3>
				<p>仅在信用中国（山东泰安）网站公示的行政处罚信息，信用修复政策执行国家发展改革委发改办财金（2019）527号文件。行政相对人在提交修复申请前，请认真阅读修复指南和流程指引，将加盖单位公章的
					《信用中国（山东泰安）网站行政处罚信息公示提前撤销申请表》连同修复相关材料扫描并发送至邮箱tasxyb@ta.shandong.cn。信用修复申请受理后，我们将在3个工作日内办结并反馈。
				</p>
			</div>
			<div class="right-box">
				<img src="@/static/images/repair/lc.png" class="circle" alt="">
				<h3>流程指引</h3>
				<img class="process-img" src="@/static/images/repair/xyxfta.png" alt="">
			</div>
			<div class="right-box">
				<img src="@/static/images/repair/qdsm.png" class="circle" alt="">
				<h3>材料清单及说明</h3>
				<process routeName="city" />
			</div>
			<div class="right-link">
				<img src="@/static/images/repair/zn.png" class="circle" alt="">
				<a href="https://www.creditchina.gov.cn/xyxf/xfzn/" target="_blank">
					修复指南&nbsp;&nbsp;<i class="iconfont icon-chain"></i>
				</a>
			</div>
			<div class="right-link">
				<img src="@/static/images/repair/zxpx.png" class="circle" alt="">
				<a href="https://www.creditchina.gov.cn/pxpt/" target="_blank">
					信用中国网站公益性在线培训平台&nbsp;&nbsp;<i class="iconfont icon-chain"></i>
				</a>
			</div>
			<div class="right-link">
				<img src="@/static/images/repair/sm-i.png" class="circle" alt="">
				<a href="http://credit.taian.gov.cn:80/xyfw/downloadFile.do?flag=xyxfcx">
					信用中国（山东泰安）网站行政处罚信息公示提前撤销申请表.doc &nbsp;&nbsp;<img border="0" src="@/static/images/repair/doc.gif"></a>
			</div>
			<div class="right-link">
				<img src="@/static/images/repair/cjwd.png" class="circle" alt="">
				<a href="https://www.creditchina.gov.cn/xyxf/cjwd/" target="_blank">
					常见问答&nbsp;&nbsp;<i class="iconfont icon-chain">&nbsp;</i></a>
			</div>
			<div class="right-link">
				<img src="@/static/images/repair/dh.png" class="circle" alt="">
				<p>咨询电话：0538-6990180</p>
			</div>
		</div>

	</div>
</template>

<script>
import process from '@/components/process';
export default {
	components: {
		process
	},
	data() {
		return {}
	},
	created() { },
	mounted() { },
	methods: {},
	computed: {},
	watch: {},
}
</script>
<style lang='scss' >
	.province-wrap {
		padding: 26px 36px;
		.province-box {
			border-left: 2px solid #ddd;

			.right-box {
				margin-top: 26px;
				padding-left: 46px;
				position: relative;
				h3 {
					font-size: 18px;
					line-height: 1.1;
					color: #000;
					margin-top: 20px;
					margin-bottom: 10px;
					font-weight: 500;
				}
				p {
					text-indent: 2em;
					line-height: 28px;
					font-size: 16px;
					margin-top: 26px;
				}
				img.circle {
					position: absolute;
					top: 0;
					left: -14px;
					vertical-align: middle;
				}
				img.process-img {
					margin-top: 20px;
					width: 100%;
				}
			}

			.right-link {
				font-size: 18px;
				line-height: 46px;
				margin-top: 26px;
				padding-left: 46px;
				position: relative;
				img.circle {
					position: absolute;
					top: 11px;
					left: -14px;
				}
				a {
					color: #0063ba;
					font-size: 15px;
					i.iconfont {
						font-size: 14px;
					}
				}
			}
		}
	}
</style>